import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { HomeIcon } from '../../icons/Home';
import { ProfileIcon } from '../../icons/Profile';
import { useAuth, useLoginActions } from '../../hooks/useAuth';
import { PUBLIC_URL } from '../../config';

export const NavbarContainer = () => {
    const location = useLocation();
    const { authStore } = useAuth();
    const { openLogin, openMyAccount } = useLoginActions();

    const shouldShowHomeIcon = () => {
        switch (location.pathname) {
            case '/':
            case '/entered':
                return false;
            default:
                return true;
        }
    };

    return (
        <Navbar
            showHome={shouldShowHomeIcon()}
            loggedIn={authStore.loggedIn}
            openLogin={openLogin}
            openMyAccount={openMyAccount}
        />
    );
};

export const Navbar = ({ showHome, loggedIn, openLogin, openMyAccount }) => {
    return (
        <Styled.Wrapper>
            <Styled.NavItems>
                {showHome ? (
                    <Link to="/">
                        <HomeIcon />
                    </Link>
                ) : (
                    <Styled.EmptyHome />
                )}
                <a href="https://itv7.itv.com/">
                    <Styled.Logo
                        height={28}
                        width={49}
                        src={`${PUBLIC_URL}/img/logos/itv7-light.png`}
                    />
                </a>
                {loggedIn ? (
                    <Styled.LoginButton onClick={openMyAccount}>
                        <ProfileIcon />
                    </Styled.LoginButton>
                ) : (
                    <Styled.LoginButton onClick={openLogin}>
                        <ProfileIcon />
                    </Styled.LoginButton>
                )}
            </Styled.NavItems>
        </Styled.Wrapper>
    );
};

Navbar.propTypes = {
    showHome: PropTypes.bool.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    openLogin: PropTypes.func.isRequired,
    openMyAccount: PropTypes.func.isRequired
};

export default Navbar;
